(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dos-video-autoplay"] && !Shopify.designMode) return;
  try {
    (function () {
  function initialize() {
    if (!('IntersectionObserver' in window)) return;
    const main = document.querySelector('main');
    if (!main) return;
    const videos = new Map();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function pause(video, state) {
      if (video.paused) return;
      state.automaticPauses += 1;
      video.pause();
    }

    function synchronize(video, state) {
      if (!state.visible || document.hidden) {
        pause(video, state);
        return;
      }
      if (reducedMotion.matches || state.manualPaused || video.ended || state.pending || !video.paused) return;
      state.pending = true;
      Promise.resolve(video.play()).then(function () {
        state.pending = false;
        if (!state.visible || document.hidden || reducedMotion.matches) pause(video, state);
      }).catch(function () {
        state.pending = false;
      });
    }

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        const state = videos.get(entry.target);
        if (!state) return;
        state.visible = entry.isIntersecting && entry.intersectionRatio >= 0.35;
        synchronize(entry.target, state);
      });
    }, { threshold: [0, 0.35] });

    function register(video) {
      if (videos.has(video) || video.closest('[data-dos-hero]')) return;
      const state = { visible: false, manualPaused: false, automaticPauses: 0, pending: false };
      video.autoplay = false;
      video.defaultMuted = true;
      video.muted = true;
      video.playsInline = true;
      video.controls = true;
      state.onPause = function () {
        if (state.automaticPauses > 0) state.automaticPauses -= 1;
        else if (!video.ended) state.manualPaused = true;
      };
      state.onPlay = function () { state.manualPaused = false; };
      video.addEventListener('pause', state.onPause);
      video.addEventListener('play', state.onPlay);
      videos.set(video, state);
      observer.observe(video);
    }

    function scan() {
      main.querySelectorAll('video').forEach(register);
      videos.forEach(function (state, video) {
        if (video.isConnected) return;
        pause(video, state);
        observer.unobserve(video);
        video.removeEventListener('pause', state.onPause);
        video.removeEventListener('play', state.onPlay);
        videos.delete(video);
      });
    }

    document.addEventListener('visibilitychange', function () {
      videos.forEach(function (state, video) { synchronize(video, state); });
    });
    reducedMotion.addEventListener('change', function () {
      videos.forEach(function (state, video) {
        if (reducedMotion.matches) pause(video, state);
        else synchronize(video, state);
      });
    });
    new MutationObserver(scan).observe(main, { childList: true, subtree: true });
    scan();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
  } catch(e) { console.error(e); }
})();

})();
